import * as React from 'react';
import { FooterBase } from '~shared/components/Footer/FooterBase';
import { Grid } from '~ui/components/layout/Box';
import { useLayoutIsXS } from '../../Responsive/client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Footer for the waiter app.
 */
export var WaiterFooter = function WaiterFooter() {
  var isMobile = useLayoutIsXS();
  return /*#__PURE__*/_jsx(Grid, {
    as: "footer",
    rowGap: "extraLarge",
    padding: {
      horizontal: "none",
      vertical: "large"
    },
    children: /*#__PURE__*/_jsx(FooterBase, {
      isMinimal: true,
      isMobile: isMobile
    })
  });
};